import { IDeaRegistration, IRenewable, teamEnableRoles } from '..';
import { differenceInDays } from 'date-fns';
import { filter as lfilter, flatten } from 'lodash/fp';
import { not, groupBy } from 'rambda';
import { contramap } from 'fp-ts/Ord';
import * as S from 'fp-ts/string';
import { flow, pipe } from 'fp-ts/function';
import { sortBy, filter, isEmpty } from 'fp-ts/ReadonlyArray';

const deaNumberOrd = pipe(
  S.Ord,
  contramap((p: IRenewable) => p.deaNumber)
);
export const sortRenewablByDeaNum = sortBy([deaNumberOrd]);

export const allowApprove = flow(
  filter<IDeaRegistration>(
    ({ role, regStatus }) =>
      regStatus === 'ACTIVE' && teamEnableRoles.indexOf(role) !== -1
  ),
  isEmpty,
  not
);

const deaNumOrd = pipe(
  S.Ord,
  contramap((p: IDeaRegistration) => p.deaNum)
);
export const sortDeaRegistrationByDeaNum = sortBy([deaNumOrd]);

export const filterBySingleDeaNum: (
  a: IDeaRegistration[]
) => IDeaRegistration[] = flow(
  groupBy<IDeaRegistration>(a => a.deaNum),
  lfilter<IDeaRegistration[]>(a => a.length === 1),
  flatten
);

export const filterByExpireIn45Days = filter<IDeaRegistration>(
  ({ expDt }) => expDt !== null && differenceInDays(expDt, Date.now()) <= 45
);
